import { gql } from '@apollo/client';

export const getAllReportType = gql`query getAllReportType($currentPage: Int, $searchList: String) {
    getAllReportType(currentPage: $currentPage, searchList: $searchList) {
      results {
        id
       reportType
       reportContent
				DynamicReportTypeData{
					id
					name
					value
					language
				}
      }
      count
      status
      errorMessage
    }
  }`;

export const getReportType = gql`query getReportType($id:Int!){
  getReportType(id:$id){
    result{
      id
      reportType
      reportContent
			DynamicReportTypeData{
				language
				name
				value
				reportId
				id
			}
    }
    status
    errorMessage
  }
}`;

export const updateReportTypeMutation = gql`mutation updateReportType($id: Int, $dynamicReportTypeData: String) {
  updateReportType(
    id: $id
    dynamicReportTypeData: $dynamicReportTypeData
  ) {
    results {
      reportType
      reportContent
      id
      isActive
    }
    status
    errorMessage
    count
  }
}`;

export const deleteReportType = gql`
mutation deleteReportType($id: Int!){
  deleteReportType(id: $id){
      status
      errorMessage
  }
}`;

export const getAllUserReportType = gql`query getAllUserReportType {
  getAllUserReportType {
    results {
      reportType
      reportContent
      id
      isActive
      DynamicReportTypeData {
        id
        reportId
        name
        value
        language
      }
    }
    status
    errorMessage
  }
}`;
